var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6.5c3.79,0,7.17,2.13,8.82,5.5c-1.65,3.37-5.03,5.5-8.82,5.5S4.83,15.37,3.18,12C4.83,8.63,8.21,6.5,12,6.5 M12,4.5 c-4.8448,0-9.0042,2.9199-10.8316,7.0949c-0.1119,0.2557-0.1119,0.5544,0,0.8101C2.9958,16.5801,7.1552,19.5,12,19.5 s9.0042-2.9199,10.8316-7.0949c0.1119-0.2557,0.1119-0.5544,0-0.8101C21.0042,7.4199,16.8448,4.5,12,4.5z M12,8 c-2.2044,0-4,1.7956-4,4s1.7956,4,4,4s4-1.7956,4-4S14.2044,8,12,8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityTomorrowio);
export default __webpack_public_path__ + "static/media/visibility-tomorrowio.1c784ac17017b6d753f0f02b974e57e9.svg";
export { ForwardRef as ReactComponent };